import type { ReactNode } from "react";
import { cn } from "@/lib/cn";

// KpiStrip = WRAPPING auto-fit grid for KPI tiles (wraps to new rows when
// narrow). For the Overview forced-single-row metric ribbon that must never
// wrap, use RightNowStrip's repeat(N, minmax(0, 1fr)) pattern instead.
//
// Layout-only: no color, no tokens, no i18n — theme/print/lang correctness is
// inherited unchanged from the tiles it wraps. The auto-fit + minmax inline
// style is used (rather than a Tailwind arbitrary value) because repeat(
// auto-fit, ...) with an embedded minmax is brittle to purge and `min` is a
// prop; this mirrors RightNowStrip's inline grid-template approach.
export function KpiStrip({
  min = "11rem",
  gap = "gap-3",
  className,
  children,
}: {
  min?: string;
  gap?: string;
  className?: string;
  children: ReactNode;
}) {
  return (
    <div
      className={cn("grid", gap, className)}
      style={{ gridTemplateColumns: `repeat(auto-fit, minmax(${min}, 1fr))` }}
    >
      {children}
    </div>
  );
}
